<template>
  <section class="w-100 d-flex align-items-center">
    <b-container class="w-100 py-5 text-center">
      <div class="success-window">
        <h4 class="display-4 text-dark">Contato via WhatsApp</h4>
        <p class="text-secondary">Clique no botão abaixo para ser redirecionado.</p>

        <b-button
          variant="purple"
          v-html="'Iniciar conversa'"
          class="text-uppercase text-white px-5 py-3 mt-3"
          v-on:click="openWhatsapp()"
        ></b-button>
      </div>
    </b-container>
  </section>
</template>
<style scoped>
.success-window {
  position: relative;
  top: 100px;
  left: 0;
  width: 100%;
  min-height: 50vh;
}
</style>

<script>
export default {
  methods: {
    openWhatsapp() {
      window.open("https://wa.me/5544999040128", "_blank");
    },
  },
};
</script>